// extracted by mini-css-extract-plugin
export var formContainer = "_jy-0";
export var message = "_jy-1";